import * as _ from 'lodash';
import { AuthProvider } from '../auth/auth';

export let placeTypes: any[] = [
  /*
   *  icon - Used in place-icon.html
   *  tile - Used in place-icon.html
   *  isActive - Used in place-icon.html
   *  placeType - Used in place like confirm-route.html (logConfirmedTripEvents)
   *  id - used in this file (placeTypeFilter)
   */
  {
    icon: 'Pilot_Flying_J',
    title: 'Pilot\nFlying J',
    isActive: false,
    placeType: 'TRUCK_STOP',
    id: 'PILOT',
    categories: ['ALL', 'PARKING', 'FUEL'],
  },
  {
    icon: 'Loves',
    title: "Love's\nAM Best",
    isActive: false,
    placeType: 'TRUCK_STOP',
    id: 'LOVES',
    categories: ['ALL', 'PARKING', 'FUEL'],
  },
  {
    icon: 'TA',
    title: 'TA Petro',
    isActive: false,
    placeType: 'TRUCK_STOP',
    id: 'TA_PETRO',
    categories: ['ALL', 'PARKING', 'FUEL'],
  },
  {
    icon: 'Rest_Area',
    title: 'Rest Stop',
    isActive: false,
    placeType: 'REST_AREA',
    id: 'REST_AREA',
    categories: ['ALL', 'PARKING'],
  },
  {
    icon: 'Weigh_Station',
    title: 'Weigh Station',
    isActive: false,
    id: 'WEIGH_STATION_OVERALL',
    placeType: 'WEIGH_STATION',
    categories: ['ALL', 'OTHER'],
  },
  {
    icon: 'Parking',
    title: 'Other Parking',
    genericTitle: 'Parking',
    isActive: false,
    placeType: 'PARKING',
    id: 'PARKING_OVERALL',
    categories: ['ALL', 'PARKING'],
  },
  {
    icon: 'CAT_Scales',
    iconPin: 'Cat_Scale',
    title: 'CAT Scale',
    isActive: false,
    placeType: 'CAT_SCALE',
    id: 'CAT_SCALE',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'Wrecker_Services', // note spelling
    title: 'Roadside Assistance',
    isActive: false,
    placeType: 'WRECKER_SERVICES',
    id: 'WRECKER_SERVICES',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'Sapp_Bros', // note spelling
    title: 'Sapp Bros.',
    isActive: false,
    placeType: 'TRUCK_STOP',
    id: 'SAPP_BROS',
    categories: ['ALL', 'PARKING'],
  },
  {
    icon: 'Independant_Truck_Stop',
    title: 'Other\nTruck Stop',
    isActive: false,
    id: 'INDEPENDENT_TRUCK_STOP',
    placeType: 'TRUCK_STOP',
    categories: ['ALL', 'PARKING'],
  },
  {
    icon: 'Kwik_Trip',
    title: 'Kwik Trip\nKwik Star',
    isActive: false,
    placeType: 'TRUCK_STOP',
    id: 'KWIK_TRIP',
    categories: ['ALL', 'PARKING', 'FUEL'],
  },
  {
    icon: 'Walmart',
    title: 'Walmart',
    isActive: false,
    placeType: 'WALMART',
    id: 'WALMART',
    categories: ['ALL'],
  },
  {
    icon: 'Truck_Wash',
    title: 'Truck Wash',
    isActive: false,
    placeType: 'TRUCK_WASH',
    id: 'TRUCK_WASH_OVERALL',
    categories: ['ALL'],
  },
  {
    icon: 'Speedco',
    title: 'Speedco',
    isActive: false,
    placeType: 'SPEEDCO',
    id: 'SPEEDCO',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'Freightliner',
    title: 'Freightliner',
    isActive: false,
    placeType: 'FREIGHTLINER',
    id: 'FREIGHTLINER',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'International',
    title: 'International',
    isActive: false,
    placeType: 'INTERNATIONAL',
    id: 'INTERNATIONAL',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'Casino',
    title: 'Casinos',
    isActive: false,
    placeType: 'CASINO',
    id: 'CASINO',
    categories: ['ALL', 'PARKING'],
  },
  {
    icon: 'Kenworth',
    title: 'Kenworth',
    isActive: false,
    placeType: 'KENWORTH',
    id: 'KENWORTH',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'APU',
    title: 'APU Dealers',
    isActive: false,
    placeType: 'APU_DEALER_SERVICE',
    id: 'APU_DEALER_SERVICE',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'Maintenence', // note spelling
    title: 'Other Maintenance',
    genericTitle: 'Maintenance',
    isActive: false,
    placeType: 'MAINTENANCE',
    id: 'MAINTENANCE_OVERALL',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'Peterbilt',
    title: 'Peterbilt',
    isActive: false,
    placeType: 'PETERBILT',
    id: 'PETERBILT',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'Mack',
    title: 'Mack',
    isActive: false,
    placeType: 'MACK',
    id: 'MACK',
    categories: ['ALL', 'MAINTENANCE'],
  },
  {
    icon: 'Volvo',
    title: 'Volvo',
    isActive: false,
    placeType: 'VOLVO',
    id: 'VOLVO',
    categories: ['ALL', 'MAINTENANCE'],
  },
  { skip: '-----------------------------------' },

  {
    icon: 'Truck_Stop',
    title: 'Truck Stop',
    isActive: false,
    placeType: 'TRUCK_STOP',
    id: 'TRUCK_STOP_OVERALL',
    query: { placeType: 'TRUCK_STOP' },
    categories: [],
  },

  {
    icon: 'Laundromat', // note spelling
    title: 'Laundromat',
    isActive: false,
    placeType: 'LAUNDROMAT',
    id: 'LAUNDROMAT',
    categories: [],
  },

  {
    icon: 'Low_Clearence',
    title: 'Low Clearence',
    isActive: false,
    hideFromMap: true,
    placeType: 'LOW_CLEARANCE',
    id: 'LOW_CLEARANCE',
    categories: ['OTHER'],
  },

  // {
  //   icon: 'Fuel',
  //   title: 'Other Fuel',
  //   isActive: false,
  //   placeType: 'INDEPENDENT_FUEL',
  //   id: 'INDEPENDENT_FUEL',
  //   // there are no "independent fuel places" ... they are just truck stops
  //   query: { placeId: 'INDEPENDENT_TRUCK_STOP' },
  //   categories: [
  // },
];

let idLookup = _.keyBy(placeTypes, 'id');
let typeLookup = _.keyBy(placeTypes, 'placeType');

export function placeTypeIcon(place, type?) {
  if (type) {
    // there are some differences, for example, with iconPin
    let s =
      _.get(idLookup, `${place.placeId}.${type}`) ||
      _.get(typeLookup, `${place.placeType}.${type}`);
    if (s) {
      return s;
    }
  }

  let s =
    _.get(idLookup, `${place.placeId}.icon`) ||
    _.get(typeLookup, `${place.placeType}.icon`) ||
    'Truck_Stop';

  if (place.placeType === 'WEIGH_STATION') {
    // TODO: get icons
    let status = getWeighStatus(place);
    if (status === 'OPEN') {
      s = 'Status_Weigh_Station_Open';
    } else if (status === 'CLOSED') {
      s = 'Status_Weigh_Station_Closed';
    }
  }

  return s;

  function getWeighStatus(d) {
    const first = <any>_.first(_.get(d, 'info.openForBusiness'));

    if (first) {
      return first.status;
    }
  }
}

export function placeTypeFilter(...args) {
  const types = [];

  _.each(args, a => {
    _.each(placeTypes, p => {
      if (_.includes(p.categories, a) || p.placeType === a || p.id === a) {
        types.push(p);
      }
    });
  });

  return _.uniq(types);
}



// WEBPACK FOOTER //
// ./src/providers/trip-service/place-types.ts